import type { ProjectDocument } from '@bigint-project/cloud-contracts';
import { BIGINT_PROJECT_CLOUD_EXTENSION_KEY } from '@bigint-project/calendar-catalog';

export function toBprojFile(document: ProjectDocument): Readonly<Record<string, unknown>> {
  const view = document.view.known === null
    ? null
    : { ...document.view.unknown, ...document.view.known };
  const unknownTopLevelFields = Object.fromEntries(
    Object.entries(document.unknownTopLevelFields)
      .filter(([key]) => key !== BIGINT_PROJECT_CLOUD_EXTENSION_KEY),
  );
  const calendarPinsExtension = !document.calendarPins?.length
    ? {}
    : {
      [BIGINT_PROJECT_CLOUD_EXTENSION_KEY]: {
        extensionVersion: 1,
        calendarPins: document.calendarPins.map((pin) => ({
          ...pin,
          normalWorkingTimes: pin.normalWorkingTimes.map((time) => ({ ...time })),
          managedExceptionIds: [...pin.managedExceptionIds],
        })),
      },
    };
  return {
    ...unknownTopLevelFields,
    ...calendarPinsExtension,
    formatVersion: document.formatVersion,
    savedAt: new Date().toISOString(),
    project: document.project,
    view,
  };
}

function safeFilename(name: string): string {
  const normalized = name.trim().replace(/[\\/:*?"<>|\u0000-\u001F]/g, '-');
  return normalized.length > 0 ? normalized : 'project';
}

export function downloadBproj(document: ProjectDocument): void {
  const blob = new Blob([JSON.stringify(toBprojFile(document), null, 2)], {
    type: 'application/json;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const anchor = window.document.createElement('a');
  anchor.href = url;
  anchor.download = `${safeFilename(document.name)}.bproj`;
  anchor.click();
  URL.revokeObjectURL(url);
}
